import { render, staticRenderFns } from "./OneTitle.vue?vue&type=template&id=da0dc15e&scoped=true&"
import script from "./OneTitle.vue?vue&type=script&lang=js&"
export * from "./OneTitle.vue?vue&type=script&lang=js&"
import style0 from "./OneTitle.vue?vue&type=style&index=0&id=da0dc15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0dc15e",
  null
  
)

export default component.exports